(function() {
  define('bazemont/event/trash',['angular'], function() {
    'use strict';
    return angular.module('bazemontEventTrash', []).component('bazemontEventTrash', {
      template: '<a href="" ng-click="$ctrl.trash()" ng-transclude></span>',
      transclude: true,
      bindings: {
        event: '='
      },
      controller: [
        'TlhConfirmModalService', function(TlhConfirmModalService) {
          var vm;
          vm = this;
          vm.trash = function() {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cet évènement ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                return vm.event.isActive = false;
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=trash.js.map
;
